import { User } from "../interfaces/user.interface";
import { GetMeUserResponse } from "../modules/me/interfaces/get-me-user";
import { GetUsersResponse } from "../modules/user/interfaces/get-users";

export const userMapper = {
  mapResponseToUser(response: GetMeUserResponse): User {
    return {
      id: response.id,
      company_id: response.company_id, 
      name: response.name,
      email: response.email,
      roles: response.roles,
      privileges: {
        superAdmin: response.roles.includes(1),
        writeProduct: response.roles.includes(2),
        readProduct: response.roles.includes(3),
        writeMaster: response.roles.includes(4),
        readBusiness: response.roles.includes(5),
        writeBusiness: response.roles.includes(6),
        readContainer: response.roles.includes(7),
        writeContainer: response.roles.includes(8),
        readReception: response.roles.includes(9),
        writeReception: response.roles.includes(10),
        readWarehouse: response.roles.includes(11),
        writeWarehouse: response.roles.includes(12),
        readLocation: response.roles.includes(13),
        writeLocation: response.roles.includes(14),
      },
    };
  },
  mapResponseToUsers(response: GetUsersResponse): User[] {
    return response.users.map((user: GetMeUserResponse) => this.mapResponseToUser(user))
  } 
};